@if (contractorInvoiceDocuments(); as invoiceDocuments) {
  <section>
    <onyx-information-heading>
      {{ 'labels.documents' | translate }}
    </onyx-information-heading>

    @if (invoiceDocuments.requireDocuments) {
      <ng-container
        *ngTemplateOutlet="
          shippingTypeTemplate;
          context: {
            shippingType: invoiceDocuments.shippingType,
            internalPortal: invoiceDocuments.internalPortal,
          }
        "
      ></ng-container>
    } @else {
      <p class="f-muted">{{ 'labels.invoiceDocumentsOptional' | translate }}</p>
    }
  </section>
}

@if (contractorInvoice(); as invoice) {
  <section>
    <onyx-information-heading>
      {{ 'labels.invoices' | translate }}
    </onyx-information-heading>

    <onyx-information-list>
      @let isSmall = variant() === 's';
      @if (!isSmall) {
        <onyx-information-row label="labels.invoicesType">
          <div class="invoices-type">
            <span>
              {{
                `${DictionaryCode.INVOICE_TYPE}.${invoice.defaultType}`
                  | translate
              }}
            </span>

            @if (invoice.collectiveInvoiceIssueTerm) {
              <app-contractor-invoice-collective-issue-term
                [invoice]="invoice"
              ></app-contractor-invoice-collective-issue-term>
            }
          </div>
        </onyx-information-row>
      }

      <ng-container
        *ngTemplateOutlet="
          shippingTypeTemplate;
          context: {
            shippingType: invoice.shippingType,
            internalPortal: invoice.internalPortal,
          }
        "
      ></ng-container>

      @if (!isSmall) {
        <onyx-information-row label="labels.currency">
          @if (invoice.primaryCurrency; as currency) {
            {{ `${DictionaryCode.CURRENCY}.${currency}` | translate }}
          } @else {
            -
          }
        </onyx-information-row>

        <onyx-information-row label="labels.language">
          @if (invoice.primaryLanguage; as language) {
            {{ `${DictionaryCode.LANGUAGE}.${language}` | translate }}
          } @else {
            -
          }
        </onyx-information-row>
      }
    </onyx-information-list>
  </section>
}

<ng-template
  let-shippingType="shippingType"
  let-internalPortal="internalPortal"
  #shippingTypeTemplate
>
  <onyx-information-list>
    @if (shippingType?.emails.length && shippingType.emails; as emails) {
      <onyx-information-row label="labels.mailShipping">
        <p
          [onyxTooltip]="emailsTooltipTemplate"
          [onyxTooltipTemplateContext]="{ emails: emails }"
          [onyxTooltipDisabled]="emails.length <= 2"
        >
          {{ emails | join: { maxLength: 2 } }}
        </p>
      </onyx-information-row>
    }

    @if (internalPortal) {
      <onyx-information-row label="labels.internalPortalShipping">
        <div class="internal-portal">
          @for (item of internalPortal; track item) {
            {{ item }}
          }
        </div>
      </onyx-information-row>
    }

    @if (shippingType?.traditionalMail) {
      <onyx-information-row label="labels.snailMailShipping">
        @if (shippingType.isOriginalDocumentRequired) {
          {{ 'labels.originalDocumentRequired' | translate }}
        } @else {
          {{ 'labels.originalDocumentNotRequired' | translate }}
        }
      </onyx-information-row>
    }
  </onyx-information-list>
</ng-template>

<ng-template let-emails="emails" #emailsTooltipTemplate>
  <div class="tooltip">
    <p>{{ 'labels.mailShipping' | translate }}</p>

    @for (email of emails; track email) {
      <div class="item">
        <span>• {{ email }}</span>
      </div>
    }
  </div>
</ng-template>
